<script lang="ts">
	//Helpers
	import { formatSnakeCaseToTitle } from '../../../../helpers/utilities';
	//Components
	import Action from '../WebHooksG1/Action.svelte';
	import ActionPreviewListV2 from '../WebHookComponentsG1/ActionPreviewListV2.svelte';
	//Design system components
	import { Modal } from '@Shelly/shelly-design-system';
	import { hasExternalSensors } from 'src/helpers/ext_sensor_helpers';
	import { SLEEPING_TYPES, HALF_SLEEPING_TYPES } from '../../../../constants';
	import { format } from 'svelte-i18n';
	import { refactorString } from './web_hooks_action_title_helper';
	import { classMap } from '@Shelly/shelly-design-system/helpers/component-utils';

	export let deviceActions,
		type = 'action',
		component = Action;

	let showModal = false;

	let openedSettings = [];

	const device = deviceActions.device;

	$: actions = deviceActions?.[device?.id];

	for (let title in deviceActions[device.id]) {
		if (deviceActions[device.id][title].enabled) {
			openedSettings.push(Object.keys(deviceActions).indexOf(title));
		}
	}
	let activeData = {
		device,
		data: undefined,
		action: undefined,
		type,
	};
	const editMode = (e) => {
		[activeData.action, activeData.data] = [e.detail.action, e.detail.setting];
		showModal = true;
	};
	const handleClose = () => {
		showModal = false;
		activeData = {
			device,
			data: undefined,
			action: undefined,
			type,
		};
	};

	const filterActions = (a) => {
		// if device doesn't have addon remove report_url from actions
		if (
			!hasExternalSensors(device) &&
			!SLEEPING_TYPES.includes(device.type) &&
			!HALF_SLEEPING_TYPES.includes(device.type)
		) {
			if (a[0] !== 'report_url') {
				return a;
			}
		} else {
			return a;
		}
	};
</script>

{#if typeof actions !== 'undefined'}
	{#each Object.entries(actions).filter((a) => filterActions(a)) as [action, setting], i}
		{#key action}
			<ActionPreviewListV2
				class={classMap({
					'mb-s': i < Object.entries(actions).length - 1,
				})}
				{setting}
				{action}
				{device}
				on:edit={editMode}
			/>
		{/key}
	{/each}
{/if}
{#if showModal}
	<Modal
		on:close={handleClose}
		{showModal}
		title={formatSnakeCaseToTitle(
			$format(`${refactorString(activeData.action, device)}`, {
				default: `${refactorString(activeData.action, device)}`,
			}),
		)}
		hideSlotFooter
		removeScrollPadding
	>
		<svelte:component
			this={component}
			{deviceActions}
			data={activeData.data}
			action={activeData.action}
			{type}
			on:actionsUpdate
			slot="content"
			on:close={handleClose}
		/>
	</Modal>
{/if}
